import { render, staticRenderFns } from "./ReviewerCell.vue?vue&type=template&id=081288ab"
import script from "./ReviewerCell.vue?vue&type=script&lang=js"
export * from "./ReviewerCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports